import { UserImage } from "./user-image.component";
export { UserImage };
